lmApp
  .controller('LiveController', ['$routeParams', '$location', '$q', '$scope', '$templateCache', '$compile', '$rootScope', '$timeout', '$interval', 'AssetService', 'MetadataService', 'ModalWindowService', 'ToastService', 'ValidatorService', 'ModalConfirmService', 'ImportService', 'AssetResource', 'TimezoneService', 'ManagerResource', 'GenreResource', 'CategoryResource', 'LiveEventResource', 'SubscriberResource', 'SubscriberV2Service', 'LiveEventService', 'AssetV2Service',
    function ($routeParams, $location, $q, $scope, $templateCache, $compile, $rootScope, $timeout, $interval, AssetService, MetadataService, ModalWindowService, ToastService, ValidatorService, ModalConfirmService, ImportService, AssetResource, TimezoneService, ManagerResource, GenreResource, CategoryResource, LiveEventResource, SubscriberResource, SubscriberV2Service, LiveEventService, AssetV2Service) {
      // Timezone
      var timezone = _.find(TimezoneService.Timezones, {title: 'UTC'});
      $scope.tz = timezone.title;
      ManagerResource.get().$promise
          .then(function (result) {
            if (result.length !== 0) {
              var manager = _.find(result, {username: $rootScope.globals.currentUser.username});
              if (manager) {
                timezone = _.find(TimezoneService.Timezones, {title: manager.ui_timezone || 'UTC'});
                $scope.tz = timezone.title;
              }
            }
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason, 'silent');
          });

      $scope.convertTime = function (dt) {
        return TimezoneService.addTimezoneToDate(dt, timezone)
      };

      /////////////
      $scope.assets = [];
      $scope.limit = 20;
      $scope.offset = 0;
      $scope.total = 0;

      $scope.filters = {
        name: '',
        lcn: '',
        packages: [],
        categories: [],
        genres: []
      };
      ///
      $scope.findSubscriberLoading = false;
      $scope.subscribers = []
      $scope.selectedSubscriber = {}
      $scope.catchupSubscriber = {}
      $scope.selectedResource = {
          id: 0,
          loading: false,
          url: '',
          urlEsc: '',
          error: '',
          subscriber: {},
      }

      $scope.date = {}
      $scope.searchEvent = '';
      $scope.liveEvents = []
      $scope.liveEvent = {}
      $scope.catchupStream = {
          loading: false,
          type: 'hls',
          url: '',
          urlEsc: '',
          error: '',
          subscriber: {},
      }

      var processAsset = function(asset) {
        var processed = {
          id: asset.id,
          extid: asset.ext_id,
          createTime: asset.create_time,
          updateTime: asset.update_time,
          type: asset.type,
          name: asset.name,
          description: asset.description,
          lcn: asset.lcn,
          rotationStart: asset.rotation_start,
          rotationFinish: asset.rotation_finish,
          provider: asset.provider ? asset.provider.name : '',
          adult: asset.adult ? 'Yes' : 'No',
          categories: asset.categories || [],
          genres: asset.genres || [],
          vastId: asset.vast_id || '',
          epg: {
              id: 0,
              extid: '',
          },
          poster: {
            state: '',
            url: '',
            source: ''
          },
          streams: [],
          catchup: {
              id: 0,
              state: '',
          },
          streamResources: [],
          packages: asset.packages || [],
          rotationPeriodOK: true,
          free: asset.free || false,
          conditions: {
              ready: processCondition({})
          }
        };

        if (moment(asset.rotation_start).diff(moment()) > 0 || moment(asset.rotation_finish).diff(moment()) < 0) {
          processed.rotationPeriodOK = false;
        }

        if (asset.resources) {
            for (var i = 0; i < asset.resources.length; i++) {
                var r = asset.resources[i]
                if (r.type === 'picture') {
                    processed.poster.state = r.state;
                    processed.poster.url = r.url;
                    processed.poster.source = r.source;
                    continue
                }
                if (r.category === 'catchup') {
                    processed.catchup.id = r.id;
                    processed.catchup.state = r.state;
                }
                var pr = {
                    id: r.id,
                    type: r.type.toUpperCase(),
                    state: r.state,
                    deployer: r.deployer,
                    preparer: r.preparer,
                    added: r.create_time,
                    updated: r.update_time,
                    private: r.private,
                    URL: r.source,
                    category: r.category,
                    tags: '',
                    depth: parseInt(r.catchup_depth) || 0
                }
                if (r.deployer_args && r.deployer_args.cdn_tag) {
                    pr.tags = r.deployer_args.cdn_tag;
                }
                if (r.type === 'dash-live' || r.type === 'hls-live' || r.type === 'shoutcast' || r.type === 'hls-live-protected' || r.type === 'dash-live-protected') {
                    processed.streams.push(pr)
                }
                processed.streamResources.push(pr)
            }
        }

        if (asset.epg) {
            processed.epg.id = asset.epg.id
            processed.epg.extid = asset.epg.ext_id
        }

        if (asset.conditions) {
          var ready = asset.conditions.filter(function(c) {
            if (c.type === 'ready') return c;
          });
          if (ready.length) {
            processed.conditions.ready = processCondition(ready[0]);
          }
        }

        return processed;
      };

      var processCondition = function (condition) {
          return {
              id: condition.id || 0,
              required: condition.required || false,
              type: condition.type || '',
              state: condition.state || ''
          }
      };

      var getTotal = function(params) {
        if (params === undefined) {
          params = {
              'type[eq]': 'channel'
          };
        }

        if (params.hasOwnProperty('$match') && params['$match'] !== '') {
            AssetResource.get(params).$promise
                .then(function (assets) {
                    $scope.total = assets.length;
                })
                .catch(function (reason) {
                    $rootScope.debugInfo(reason, 'silent');
                })
        } else {
            AssetResource.count(params).$promise
                .then(function (response) {
                    $scope.total = response.data ? response.data : 0;
                })
                .catch(function (reason) {
                    $rootScope.debugInfo(reason);
                });
        }
      };

      //getTotal();

      $scope._prevFilters = '';

      function extractLCNNumber(str) {
         const match = str.match(/^ *lcn *(\d+)/i);
         return match ? parseInt(match[1], 10) : null;
      }

      $scope.getAssets = function (silent) {
        if ($scope.loading) return;
        if (silent !== true) {
            $scope.loading = true;
            $rootScope.showLinearProgress('#liveCollectionLoader');
        }

        var params = {
            'type[eq]': 'channel'
        };

        if ($scope.filters.name.trim() !== '') {
            var lcn = extractLCNNumber($scope.filters.name.trim())
            if (lcn) {
                params['lcn[in]'] = lcn
            } else {
                params['$match'] = $scope.filters.name.trim();
            }
        }

          if ($scope.filters.genres.length > 0) {
              var ids = [];
              for (var i = 0; i < $scope.filters.genres.length; i++) {
                  ids.push($scope.filters.genres[i].id);
              }
              params['genres.id[in]'] = ids.join(',');
          }

          if ($scope.filters.categories.length > 0) {
              var ids = [];
              for (var i = 0; i < $scope.filters.categories.length; i++) {
                  ids.push($scope.filters.categories[i].id);
              }
              params['categories.id[in]'] = ids.join(',');
          }

        if ($scope.filters.packages.length > 0) {
            var ids = [];
            for (var i = 0; i < $scope.filters.packages.length; i++) {
                ids.push($scope.filters.packages[i].id);
            }
            params['packages.id[in]'] = ids.join(',');
        }

        getTotal(params);

        params['$limit'] = $scope.limit;
        params['$offset'] = $scope.offset;


        if (angular.toJson($scope.filters) !== $scope._prevFilters) {
          params['$offset'] = 0
          $location.search('page', 1);
          $scope.offset = 0;
          $scope.routePage = 1;
        }

        $scope._prevFilters = angular.toJson($scope.filters);

        params['$expand'] = 'resources(url),categories,genres,packages,provider,epg,country,conditions';
        params['$orderby'] =  _.get($scope.collectionData.sortBy, 'field', '');

        AssetResource.get(params).$promise
            .then(function (assets) {
              if (assets.length === 0 && $scope.routePage != 1) {
                  $scope.routePage = 1;
                  $scope.offset = 0;
                  $scope.loading = false;
                  $location.search('page', $scope.routePage);
              } else {
                  var processed = [];
                  for (var i = 0; i < assets.length; i++) {
                      var asset = assets[i];
                      processed.push(processAsset(asset));
                  }
                  $scope.assets = processed;
                  $scope.loading = false;
              }
              $rootScope.hideLinearProgress('#liveCollectionLoader');
            })
            .catch(function (reason) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#liveCollectionLoader');
              if (silent !== true) {
                  ToastService.Small({
                      title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                      color: 'amber',
                      icon: 'server-off',
                      blocked: true
                  }, 1000 * 3);
              }
              $rootScope.debugInfo(reason, 'silent');
            })
      };

      $scope.nextPage = function () {
        if ($scope.offset + $scope.limit < $scope.total) {
          $scope.offset = $scope.offset + $scope.limit;
          $scope.routePage = Number($scope.routePage) + 1;
          $location.search('page', $scope.routePage);
        }
      };

      $scope.prevPage = function () {
        if ($scope.offset - $scope.limit >= 0) {
          $scope.offset = $scope.offset - $scope.limit;
          $scope.routePage = Number($scope.routePage) - 1;
        } else {
          $scope.offset = 0;
          $scope.routePage = 1;
        }
        $location.search('page', $scope.routePage);
      };


      $scope.clearSelectedVOD = function () {
        $scope.selectedVOD = {};
        $scope.selectedResource = {
              id: 0,
              loading: false,
              url: '',
              urlEsc: '',
              error: '',
              subscriber: {},
            wvLicenseURL: '',
            fpsLicenseURL: '',
            fpsCertURL: '',
            type: '',
        }
        $location.search('asset_id', null);
      };

      $scope.isAssetSelected = function () {
        return !_.isEmpty($scope.selectedVOD);
      };

      $scope.selectVOD = function(asset) {
          $location.search('asset_id', asset.id);
      };

      $scope.selectAsset = function (asset, silent) {
        if (!asset.type) {
            if (silent !== true) {
                $scope.selectedVOD = {};
            }
            var selectedParams = {};
            if (silent !== true) {
                $scope.loading = true;
                $rootScope.showLinearProgress('#liveCollectionLoader');
            }
            selectedParams['id[eq]'] = asset.id;
            selectedParams['$expand'] = 'resources(url),categories,genres,packages,provider,epg,country,conditions';
            AssetResource.get(selectedParams).$promise
                .then(function (result) {
                    if (result.length) {
                        $scope.selectAsset(processAsset(result[0]), silent);
                    } else {
                        $location.search('asset_id', null);
                        $scope.loading = false;
                        $rootScope.hideLinearProgress('#liveCollectionLoader');
                    }
                })
                .catch(function (reason) {
                    $location.search('asset_id', null);
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#liveCollectionLoader');
                    $rootScope.debugInfo(reason, 'silent');
                });
            return;
        }

        $scope.selectedVOD = asset;
        if (silent !== true) {
            $scope.loading = true;
            $rootScope.showLinearProgress('#liveCollectionLoader');
        }
        if (asset.streams.length > 0) {
            $scope.selectedResource.id = asset.streams[0].id + ''
        }

        $scope.date.currentDate = moment.utc();
        var params = {
            'live.id[eq]': $scope.selectedVOD.id,
            'end_time[gt]': $scope.date.currentDate.startOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z',
            'start_time[lt]': $scope.date.currentDate.endOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z',
            //'start_time[gt]': $scope.date.currentDate.startOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z',
            //'end_time[lt]': $scope.date.currentDate.endOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z',
            '$expand': 'thumbnail(url),program(*)'
        };

        if ($scope.watcher) $scope.watcher();
        $scope.watcher = $scope.$watch('date.currentDate', function (newValue, oldValue) {
          if (newValue !== oldValue) {
            var params = {
              'live.id[eq]': $scope.selectedVOD.id,
              'end_time[gt]': moment(newValue).startOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z',
              'start_time[lt]': moment(newValue).endOf('day').format('YYYY-MM-DDTHH:mm:ss') + 'Z',
              '$expand': 'thumbnail(url),program(*)'
            };
            $scope.getLiveEvents(params);
          }
        });
        $scope.getLiveEvents(params);

        /*  for (var i = 0; i < $scope.selectedVOD.streams.length; i++) {
              $scope.selectedVOD.streams[i].type += "-protected"
          }*/

        var ids = [];
        ids.push(asset.id);
        for (var i = 0; i < asset.packages.length; i++) {
            ids.push(asset.packages[i].id);
        }

        $scope.selectedVOD.purchaseOptions = {};
        $scope.selectedVOD.packagePurchaseOptions = [];

        AssetService.GetAssetInId(ids)
          .then(function (assets) {
            for (var i = 0; i < assets.length; i++) {
                var a = assets[i];
                var purchaseOptions = {
                    package: a.title,
                    free: false,
                    plans: []
                };
                for (var j = 0; j < a.offers.length; j++) {
                    var offer = a.offers[j];
                    if (offer.type === 'free') {
                        purchaseOptions.free = true;
                    } else {
                        purchaseOptions.plans.push(offer.name);
                    }
                }
                if (a.id === asset.id) {
                    if (asset.free) purchaseOptions.free = true;
                    $scope.selectedVOD.purchaseOptions = purchaseOptions;
                } else {
                    $scope.selectedVOD.packagePurchaseOptions.push(purchaseOptions);
                }
            }
            $scope.loading = false;
            $rootScope.hideLinearProgress('#liveCollectionLoader');
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason, 'silent');
            $scope.loading = false;
            $rootScope.hideLinearProgress('#liveCollectionLoader');
          });


          ids = [];
          for (var i = 0; i < asset.packages.length; i++) {
              ids.push(asset.packages[i].id);
          }
          if (ids.length) {
              var params = {};
              params['id[in]'] = ids.join(',');
              params['$expand'] = 'groups';
              AssetResource.get(params).$promise
                  .then(function (assets) {
                      var groups = {};
                      for (var i = 0; i < assets.length; i++) {
                          var asset = assets[i];
                          if (asset.groups) {
                              for (var j = 0; j < asset.groups.length; j++) {
                                  if (!groups.hasOwnProperty(asset.groups[j].name)) {
                                      groups[asset.groups[j].name] = {
                                          group: asset.groups[j].name,
                                          packages: {}
                                      }
                                  }
                                  groups[asset.groups[j].name].packages[asset.name] = true;
                              }
                          }
                      }
                      $scope.selectedVOD.groups = [];
                      for (var groupName in groups) {
                          if (!groups.hasOwnProperty(groupName)) {
                              continue
                          }
                          var packages = [];
                          for (var packageName in groups[groupName].packages) {
                              if (!groups[groupName].packages.hasOwnProperty(packageName)) {
                                  continue
                              }
                              packages.push(packageName);
                          }
                          $scope.selectedVOD.groups.push({
                              name: groupName,
                              packages: packages
                          })
                      }
                  })
                  .catch(function (reason) {
                      $rootScope.debugInfo(reason, 'silent');
                  });
          }
      };

        var processLiveEvent = function(liveEvent) {
            var processed = {
                id: liveEvent.id,
                name: liveEvent.name,
                description: liveEvent.description,
                startTime: moment(liveEvent.start_time).format('HH:mm'),
                endTime: moment(liveEvent.end_time).format('HH:mm'),
                start: moment(liveEvent.start_time).format('D MMM HH:mm'),
                end: moment(liveEvent.end_time).format('D MMM HH:mm'),
                pictureURL: '',
                catchup: liveEvent.catchup,
                catchupIntegrity: liveEvent.catchup_integrity || 0,
                episodeName: liveEvent.episode_name,
                episodeDescription: liveEvent.episode_description,
                ageLimit: liveEvent.age_limit,
                programIsSeries: false,
                programGenres: [],
                programPersons: [],
                programPictures: [],
            };
            if (liveEvent.thumbnail) {
                processed.pictureURL = liveEvent.thumbnail.url;
            }
            if (liveEvent.program) {
                processed.programIsSeries = liveEvent.program.is_series || false
                processed.programGenres = liveEvent.program.genres || []
                processed.programPersons = liveEvent.program.persons || []
                if (liveEvent.program.resources) {
                    processed.programPictures = liveEvent.program.resources.map(function (item) {
                        return {
                            url: item.url,
                            category: item.category
                        }
                    })
                }
            }

            return processed;
        };

      $scope.getLiveEvents = function (params) {
          $scope.liveEvents = [];

          LiveEventResource.get(params).$promise
              .then(function (liveEvents) {
                  $scope.liveEvents = liveEvents.map(function(le) {
                      return processLiveEvent(le);
                  });
              })
              .catch(function (reason) {
                  $rootScope.debugInfo(reason);
              });
      }

      $scope.reloadAsset = function (asset) {
        var selectedParams = {};
        selectedParams['id[eq]'] = asset.id;
        selectedParams['type[eq]'] = 'channel';
        selectedParams['$expand'] = 'resources(url),categories,genres,packages,provider,epg,country,conditions';
        AssetResource.get(selectedParams).$promise
          .then(function (result) {
            if (result.length) {
              var processed = processAsset(result[0]);
              $scope.selectedVOD.updateTime = processed.updateTime;
              $scope.selectedVOD.poster = processed.poster;
              $scope.selectedVOD.streams = processed.streams;
              $scope.selectedVOD.streamResources = processed.streamResources;
              $scope.selectedVOD.conditions = processed.conditions;
            } else {
              $location.search('asset_id', null);
            }
          })
          .catch(function (reason) {
            $location.search('asset_id', null);
            $rootScope.debugInfo(reason, 'silent');
          });
        };
      /////////////

      $scope.permissions = $rootScope.permissions;

      $scope.collection = [];
      $scope.loading = false;
      $scope.importInProgress = false;
      ///

      $scope._STREAM_TYPES_ATTRS = MetadataService._STREAM_TYPES_ATTRS;

      $scope.sortOptions = [
          {title: "ID Asc", field: "id"},
          {title: "ID Desc", field: "-id"},
          {title: "Name A-Z", field: "name"},
          {title: "Name Z-A", field: "-name"},
          {title: "LCN Asc", field: "lcn"},
          {title: "LCN Desc", field: "-lcn"},
          {title: "Rotation Start Asc", field: "rotation_start"},
          {title: "Rotation Start Desc", field: "-rotation_start"},
          {title: "Rotation End Asc", field: "rotation_end"},
          {title: "Rotation End Desc", field: "-rotation_end"},
          {title: "Create Time Asc", field: "create_time"},
          {title: "Create Time Desc", field: "-create_time"},
      ];

      $scope.collectionData = {
        empty: false,
        error: '',
        filters: {
          genres: [],
          categories: [],
          keyword: ''
        },
        sortBy: {title: "ID Desc", field: "-id"},
        offset: 0,
        limit: 20,
        isStart: false,
        isEnd: false,
      };

      var sortBy = window.localStorage['live_sortby'];
      if (sortBy && sortBy !== 'undefined') {
          try {
              $scope.collectionData.sortBy = JSON.parse(sortBy);
          } catch (e) {
          }
      }

      $scope.deleteAsset = function (asset, event) {
        if (event && event.stopPropagation) event.stopPropagation();
        if (event && event.preventDefault) event.preventDefault();

        $scope.modalWindowScope = $scope.$new();
        var inner = '<span class="heavy">Are you sure you want <b>to delete</b> the ' + asset.type + ' "' + asset.name +'"?</span>';

        ModalWindowService.Open({
          content: inner,
          actions: [
            {
              title: 'I understand. Do it',
              color: 'green',
              fn: function () {
                AssetResource.remove({id: asset.id}).$promise
                  .then(function () {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#liveCollectionLoader');
                    ToastService.Small({
                      title: 'Channel: <b class="tc-white"> ' + asset.name + '</b> successfully deleted',
                      color: 'green',
                      icon: 'delete'
                    },1000 * 3);
                      $scope.getAssets();
                      if ($routeParams.asset_id) {
                          $scope.clearSelectedVOD();
                      }
                  })
                  .catch(function (reason) {
                    $scope.loading = false;
                    $rootScope.hideLinearProgress('#liveCollectionLoader');
                    $rootScope.debugInfo(reason);
                    ToastService.Small({
                      title: 'Channel: <b class="tc-white"> ' + asset.name + '</b> delete failed',
                      color: 'red',
                      icon: 'delete'
                    },1000 * 3);
                  });
              }
            },
            {
              title: 'cancel',
              color: 'red',
              fn: function () {}
            }
          ],
          onComplete: function () {
            $scope.modalWindowScope.$destroy();
          }
        });
      };

      //When modal window open = save Data for edit
      $scope.openModal = function (asset, e, isNewType, id) {
        if (e && e.preventDefault) e.preventDefault();
        if (e && e.stopPropagation) e.stopPropagation();

        var modalScope = $rootScope.$new();

        if (isNewType) {
          modalScope.asset = {type: isNewType};
        } else {
          modalScope.asset = angular.copy(asset);
        }

        modalScope.loading = false;

        modalScope.processAsset = function (asset) {
          if (modalScope.loading) return;

          if (isNewType && !id) {
            modalScope.createFn();
          } else {
            modalScope.updateFn(asset);
          }
        };

        modalScope.close = function (id) {
          if (modalScope.loading) return;

          modalScope.fullscreenToogle(false);
          ModalWindowService.Close($scope.window, false);
          if (id === -1) {
              AssetResource.update({id: asset.id}, { name: asset.name }).$promise
                  .then(function (response) {
                      $scope.selectAsset({id: asset.id});
                  })
                  .catch(function (reason) {
                  });
              return;
          }
          if (id) {
            if ($routeParams.asset_id == id) {
                $scope.selectAsset({id: id});
            } else {
                $location.search('asset_id', id);
            }
          }
        };

        modalScope.fullscreenToogle = function (state) {
          if (typeof state !== 'undefined') {
            modalScope.fullscreen = state;
          } else {
            modalScope.fullscreen = !modalScope.fullscreen;
          }

          ModalWindowService.Fullscreen($scope.window, state);
        };

        modalScope._modalWindow_ = $templateCache.get('lm-asset-edit/edit-window.tpl.html');

        modalScope._modalWindow_ = $compile(modalScope._modalWindow_)(modalScope);

        $scope.window = ModalWindowService.Open({
          content: modalScope._modalWindow_,
          navigation: $compile($templateCache.get('lm-asset-edit/navigation-buttons.tpl.html'))(modalScope),
          clear: true,
          keyboard: true,
          size: {
            s: 11,
            l: 10
          }
        });

        modalScope._modalWindow_.on('$destroy', function () {
          modalScope.$destroy();
        })
      };

      $scope.importPerform = function () {

        $timeout(function () {
          angular.element('#import_xml').trigger('click');
        });
      };

      $timeout(function () {
        angular.element('#import_xml')
          .on('change', function () {
            $scope._progress_ = angular.element('#importProgress');
            $scope._bar_ = $scope._progress_.find('.determinate');

            $scope.error = '';
            if (!this.files || !this.files.length) {
              ToastService.Small({
                title: 'Please, choose at least one file',
                color: 'red',
                icon: 'arrow-down-bold-hexagon-outline'
              }, 1000 * 60);

              return;
            }

            var file = this.files[0];

            if (file.type !== 'text/xml') {
              ToastService.Small({
                title: 'File should be in XML format',
                color: 'red',
                icon: 'arrow-down-bold-hexagon-outline'
              }, 1000 * 60);

              return;
            }

            $scope.importInProgress = true;
            $scope._progress_.css({ 'display': 'block' });

            angular.element('#import_xml').innerHTML =  angular.element('#import_xml').innerHTML;

            ImportService.UploadToCloud(file, $scope._progress_)
              .then(function (response) {
                $scope._progress_.css({ 'display': 'none' });
                $scope._bar_.css({ width: 0 });

                ImportService.CreatePerformImport(response.Location)
                  .then(function () {
                    $scope.importInProgress = false;

                    ToastService.Big({
                      title: 'Import will continue in background. Check this page later.',
                      color: 'green',
                      icon: 'arrow-down-bold-hexagon-outline'
                    }, 1000 * 60);
                  })
                  .catch(function (reason) {
                    $rootScope.debugInfo(reason);
                  });
              }, function (reason) {
                $scope.importInProgress = false;
                $scope._progress_.css({ 'display': 'none' });
                $scope._bar_.css({ width: 0 });

                $rootScope.debugInfo(reason);
              });
          });
      }, 600);

      // Stream Check
        var searchTimeout;
        $scope.findSubscriber = function(text) {
            if (!text) return;
            text = text.trim();
            if (text === '') return;
            if (searchTimeout) $timeout.cancel(searchTimeout);
            $scope.findSubscriberLoading = true;
            searchTimeout = $timeout(function () {
                var params = {};
                params['$limit'] = 1000;
                params['$match'] = text
                SubscriberResource.get(params).$promise
                    .then(function (result) {
                        var users = (result.data || []);
                        var userList = [];
                        for (var i = 0; i < users.length; i++) {
                            const subscriber = users[i];
                            userList.push({
                                id: subscriber.id,
                                title: subscriber.username,
                            });
                        }
                        $scope.subscribers = userList;
                        $scope.findSubscriberLoading = false;
                    })
                     .catch(function (reason) {
                        $rootScope.debugInfo(reason, 'silent');
                    })
            }, 650);
        };

        $scope.getSubscriberStreamURL = function(subscriber) {
            $scope.selectedResource.loading = true;
            $scope.selectedResource.subscriber = subscriber;
            $scope.refreshURL();
        };

        $scope.getCatchupStreamURL = function(subscriber) {
            $scope.catchupStream.loading = true;
            $scope.catchupStream.subscriber = subscriber;
            $scope.refreshCatchupURL();
        }

        $scope.copyURL = function(version) {
            var url = '';
            if ($scope.selectedResource.type === 'hls-live') {
                url = $rootScope.getHLSPlayerURL($scope.selectedResource.urlEsc);

            } else if ($scope.selectedResource.type === 'hls-live-protected') {
                url = 'https://vtb.axinom.com/fairplay_streaming_sample_player.html?url=' + $scope.selectedResource.urlEsc + '&license=' + $scope.selectedResource.fpsLicenseURL + '&token=&certUrl=' + $scope.selectedResource.fpsCertURL;
            }
            if ($scope.selectedResource.type === 'dash-live' || $scope.selectedResource.type === 'dash-live-protected') {
                url = 'https://shaka-player-demo.appspot.com/demo/#asset=' + $scope.selectedResource.url + ';license=' + $scope.selectedResource.wvLicenseURL;
            }
            if (version === '3.3.2') {
                url = 'https://demo24.noisypeak.com:8083/demo/#asset=' + $scope.selectedResource.url + ';license=' + $scope.selectedResource.wvLicenseURL;
            }
            if (version === 'dashif') {
                url = 'https://reference.dashif.org/dash.js/nightly/samples/dash-if-reference-player/index.html?mpd=' + $scope.selectedResource.urlEsc + '&widevine.isActive=true&widevine.drmKeySystem=com.widevine.alpha&widevine.licenseServerUrl=' + $scope.selectedResource.wvLicenseURLEsc + '&widevine.priority=0&widevine.httpTimeout=5000&widevine.audioRobustness=SW_SECURE_CRYPTO&widevine.videoRobustness=SW_SECURE_DECODE+&debug.logLevel=4';
            }
            $scope.copy(url)
        }

        $scope.copyCatchupURL = function() {
            var url = '';
            if ($scope.catchupStream.type === 'hls') {
                url = $rootScope.getHLSPlayerURL($scope.catchupStream.urlEsc);
            } else {
                url = 'https://shaka-player-demo.appspot.com/demo/#asset=' + $scope.catchupStream.url;
            }
            $scope.copy(url);
        }

        $scope.copy = function(value) {
            const tempInput = document.createElement('input')
            tempInput.style = 'position: absolute; left: -1000px; top: -1000px'
            tempInput.value = value
            document.body.appendChild(tempInput)
            tempInput.select()
            document.execCommand('copy')
            document.body.removeChild(tempInput)
        }

      $scope.refreshURL = function() {
          if (!$scope.selectedResource.subscriber.title) {
              return
          }
          $scope.selectedResource.loading = true;

          for (var i = 0; i < $scope.selectedVOD.streams.length; i++) {
              if ($scope.selectedVOD.streams[i].id == $scope.selectedResource.id) {
                  $scope.selectedResource.type = $scope.selectedVOD.streams[i].type.toLowerCase();
                  break;
              }
          }

          var clientId = '';
          for (var i=0; i < $rootScope._self.services.length; i++) {
              var service = $rootScope._self.services[i];
              if (service.instance && service.instance.platform && service.instance.platform.client_id) {
                  clientId = service.instance.platform.client_id;
                  break;
              }
          }
          if (clientId === '') {
              return;
          }

          return SubscriberV2Service.GetUserDeviceToken($scope.selectedResource.subscriber.title, clientId)
              .then(function (result) {
                  if (result.data) {
                      var token = result.data;

                      if ($scope.selectedResource.type === 'hls-live-protected' || $scope.selectedResource.type === 'dash-live-protected' || $scope.selectedResource.type === 'dash-live') {
                          AssetV2Service.GetProtectedStream($scope.selectedVOD.id, $scope.selectedResource.id, token)
                              .then(function (response) {
                                  var streamInfo = response.data;
                                  $scope.selectedResource.url = streamInfo.playback_url;
                                  $scope.selectedResource.urlEsc = escape(streamInfo.playback_url);
                                  $scope.selectedResource.loading = false;
                                  $scope.selectedResource.error = '';
                                  $scope.selectedResource.wvLicenseURL = streamInfo.wv_license_url;
                                  $scope.selectedResource.wvLicenseURLEsc = escape(streamInfo.wv_license_url);
                                  $scope.selectedResource.fpsLicenseURL = escape(streamInfo.fps_license_url);
                                  $scope.selectedResource.fpsCertURL = escape(streamInfo.fps_cert_url);
                              })
                              .catch(function (reason) {
                                  $scope.selectedResource.loading = false;
                                  if (reason.data.error) {
                                      $scope.selectedResource.error = reason.data.error.message;
                                  }
                                  $scope.selectedResource.url = '';
                                  $scope.selectedResource.urlEsc = '';
                                  $rootScope.debugInfo(reason, 'silent');
                              })
                      } else {
                          AssetV2Service.GetStream($scope.selectedVOD.id, $scope.selectedResource.id, token)
                              .then(function (response) {
                                  var streamURL = response.data;
                                  $scope.selectedResource.url = streamURL;
                                  $scope.selectedResource.urlEsc = escape(streamURL);
                                  $scope.selectedResource.loading = false;
                                  $scope.selectedResource.error = '';
                              })
                              .catch(function (reason) {
                                  $scope.selectedResource.loading = false;
                                  if (reason.data.error) {
                                      $scope.selectedResource.error = reason.data.error.message;
                                  }
                                  $scope.selectedResource.url = '';
                                  $scope.selectedResource.urlEsc = '';
                                  $rootScope.debugInfo(reason, 'silent');
                              })
                      }
                  } else {
                      $scope.selectedResource.loading = false;
                  }
              })
              .catch(function (reason) {
                  $scope.selectedResource.loading = false;
                  $rootScope.debugInfo(reason, 'silent');
              });
      };

      $scope.refreshCatchupURL = function() {
        if (!$scope.catchupStream.subscriber.title) {
          return
        }
        $scope.catchupStream.loading = true;

        var clientId = '';
        for (var i=0; i < $rootScope._self.services.length; i++) {
          var service = $rootScope._self.services[i];
          if (service.instance && service.instance.platform && service.instance.platform.client_id) {
            clientId = service.instance.platform.client_id;
            break;
          }
        }
        if (clientId === '') {
            return;
        }

        return SubscriberV2Service.GetUserDeviceToken($scope.catchupStream.subscriber.title, clientId)
            .then(function (result) {
                if (result.data) {
                    var token = result.data;

                    LiveEventService.GetStream($scope.liveEvent.id, $scope.catchupStream.type, token)
                        .then(function (response) {
                            $scope.catchupStream.url = response.data;
                            $scope.catchupStream.urlEsc = escape(response.data);
                            $scope.catchupStream.loading = false;
                            $scope.catchupStream.error = '';
                        })
                        .catch(function (reason) {
                            $scope.catchupStream.loading = false;
                            if (reason.data.error) {
                                $scope.catchupStream.error = reason.data.error.message;
                            }
                            $scope.catchupStream.url = '';
                            $scope.catchupStream.urlEsc = '';
                            $rootScope.debugInfo(reason, 'silent');
                        })
                    } else {
                        $scope.catchupStream.loading = false;
                    }
                })
                .catch(function (reason) {
                    $scope.catchupStream.loading = false;
                    $rootScope.debugInfo(reason, 'silent');
                });
        };

        $scope.openProgram = function (liveEvent) {
            if ($scope.loading) return;

            $scope.liveEvent = angular.copy(liveEvent);
            $scope.catchupStream = {
                loading: false,
                type: 'hls',
                url: '',
                urlEsc: '',
                error: '',
                subscriber: {},
            }


/*            $scope.selectStreamAsUser = function() {
                if ($scope.program.state !== 'recorded') return;
                var clientId = '';
                for (var i=0; i < $rootScope._self.services.length; i++) {
                    var service = $rootScope._self.services[i];
                    if (service.instance && service.instance.platform && service.instance.platform.client_id) {
                        clientId = service.instance.platform.client_id;
                        break;
                    }
                }
                if (clientId === '') {
                    return;
                }

                return SubscriberV2Service.GetUserDeviceToken($scope.program._subscriber_ext_id, clientId)
                    .then(function (result) {
                        if (result.data) {
                            var token = result.data;
                            $scope.playAsUser = true;

                            DVRTaskService.GetStream($scope.program.id, token, $scope.selectedStreamType)
                                .then(function (response) {
                                    $scope.selectedStream = response.data;
                                    $scope.selectedStreamEscaped = escape(response.data);
                                    $scope.selectedStreamError = '';
                                    $scope.streamLoading = false;
                                })
                                .catch(function (reason) {
                                    $scope.streamLoading = false;
                                    if (reason.data.error) {
                                        $scope.selectedStreamError = reason.data.error.message;
                                    }
                                    $scope.selectedStream = '';
                                    $rootScope.debugInfo(reason, 'silent');
                                })
                        } else {
                            $scope.streamLoading = false;
                        }
                    })
                    .catch(function (reason) {
                        $scope.streamLoading = false;
                        $rootScope.debugInfo(reason, 'silent');
                    });

            };*/

            $scope.changeType = function(type) {
                $scope.selectedStreamType = type;
                if ($scope.playAsUser) {
                    $scope.selectStreamAsUser();
                } else {
                    $scope.selectStreamAsAdmin();
                }
            };

            var inner = $templateCache.get('live-event.tpl.html');
            inner = $compile(inner)($scope);

            $scope.window = ModalWindowService.Open({
                content: inner,
                isFixed: true,
                clear: true,
                keyboard: true,
                actions: [
                    {
                        title: 'Close',
                        color: 'red',
                        fn: function () {}
                    }
                ],
                size: {
                    s: 11,
                    l: 8
                }
            });
        };

      /**
       * Init collection on controller add
       */
      $scope.routeKeyword = '';
        if (!_.isUndefined($routeParams.keyword)) {
            $scope.routeKeyword = $routeParams.keyword;
            $scope.collectionData.filters.keyword = $routeParams.keyword;
            $scope.filters.name = $routeParams.keyword;
        } else {
            $location.search('keyword', null);
        }

      $scope.routePage = 1;
      if (!_.isUndefined($routeParams.page) && $routeParams.page > 0) {
        $scope.routePage = Number($routeParams.page);
        $scope.offset = ($scope.routePage - 1) * $scope.limit;
        $scope.getAssets();
      } else {
        $location.search('page', 1);
      }

        $scope.routeAssetId = null;
        if ($routeParams.asset_id) {
            $scope.routeAssetId = Number($routeParams.asset_id);
            $scope.selectAsset({id: $scope.routeAssetId})
        } else {
            $location.search('asset_id', null);
        }

      ///
      $scope.watcherFiler = $scope.$watchCollection('collectionData.filters', function (newValue, oldValue) {
        if (oldValue && newValue) {
            $scope.filters.name = newValue.keyword
            $scope.filters.genres = newValue.genres
            $scope.filters.categories = newValue.categories

            if (newValue.keyword || newValue.genres.length || newValue.categories.length) {
                $location.search('page', 1);
            }

            if (newValue.keyword) {
                $location.search('keyword', newValue.keyword);
            } else {
                $location.search('keyword', null);
            }


/*          //TODO: Check this logic
          if (!newValue.keyword && !newValue.genres.length && !newValue.categories.length
            && (oldValue.keyword || oldValue.genres.length || oldValue.categories.length)) {
            $scope.collectionData.offset = 0;
            $location.search('page', 1);
            $scope.applyFilters(newValue);
            $location.search('keyword', null);
          }

          //if (!oldValue.keyword && !oldValue.genres.length && !oldValue.categories.length) {
          //  $scope.collectionData.offset = 0;
          //}

          if (newValue.keyword || newValue.genres.length || newValue.categories.length) {
            $location.search('page', 1);
            if (newValue.keyword) $location.search('keyword', newValue.keyword);
            $scope.applyFilters(newValue);
          }*/
        }
      });

      ////
      $scope.sortWatcher = $scope.$watchCollection('collectionData.sortBy', function (newValue, oldValue) {
        if (oldValue && newValue) {
          if (newValue.title !== oldValue.title) {
              $scope.getAssets();
              window.localStorage['live_sortby'] = JSON.stringify($scope.collectionData.sortBy);
          }
        }
      });

      /////
      $scope.$on('$routeUpdate', function () {
          // console.log("$routeUpdate");
          //console.log("$routeParams.page", $routeParams.page);
          //console.log("$scope.routePage", $scope.routePage);
          //console.log("$scope.routeAssetId", $scope.routeAssetId);
          //console.log("$routeParams.asset_id", $routeParams.asset_id);

        $scope.routePage = $routeParams.page || 1

        if ($scope.routeAssetId && !$routeParams.asset_id) {
          ModalWindowService.Close($scope.window, false);
        }

        $scope.routeAssetId = Number($routeParams.asset_id) || null;
        if ($scope.routeAssetId) {
            $scope.selectAsset({id: $scope.routeAssetId})
        } else {
            $scope.clearSelectedVOD()
        }

        $scope.getAssets();
      });

      $scope.updateIntreval = $interval(function () {
          $scope.routeAssetId = Number($routeParams.asset_id) || null;
          if ($scope.routeAssetId) {
              var silent = false;
              if ($scope.isAssetSelected()) {
                  silent = true;
              }
              $scope.reloadAsset({id: $scope.routeAssetId})
          } else {
              $scope.clearSelectedVOD();
              $scope.getAssets(true);
          }
      }, 15 * 1000);

      $scope.$on('$destroy', function () {
        $scope.watcherFiler();
        $scope.sortWatcher();
        $interval.cancel($scope.updateIntreval);

        angular.element('#import_xml').off('change');
      });

    }]);
